import { render, staticRenderFns } from "./FoodService.vue?vue&type=template&id=436bb680&scoped=true&"
import script from "./FoodService.vue?vue&type=script&lang=js&"
export * from "./FoodService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436bb680",
  null
  
)

export default component.exports